import React, { useContext } from 'react'
import { useQuery } from '@apollo/client'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid'
import AccountInformation from './components/AccountInformation'
import TagsAndMood from './components/TagsAndMood'
// import EngagementAndLearnerPace from './components/EngagementAndLearnerPace'
import StoryHighlights from './components/StoryHighlights'
import { useStyles } from './styles'
import { GET_DASHBOARD_DATA } from '../../network/dashboard/queries'
import { LabContext } from '../../context'

const DashboardPage = () => {
  const classes = useStyles()
  const { selectedLab, selectedAccount } = useContext(LabContext)
  const { loading, data: dashboardData } = useQuery(GET_DASHBOARD_DATA, {
    skip: !selectedLab,
    variables: {
      labId: selectedLab,
      accountIds: selectedAccount ? [selectedAccount] : undefined
    },
    fetchPolicy: 'no-cache'
  })

  return loading || !selectedLab ? (
    <div className={classes.loader}>
      <CircularProgress color='inherit' />
    </div>
  ) : (
    <div className={classes.root}>
      <Grid container spacing={6}>
        <Grid container item xs={12}>
          <Typography variant='h2' component='div'>
            Dashboard
          </Typography>
        </Grid>
        <Grid container item xs={12}>
          <AccountInformation data={dashboardData.coordinator.stats} />
          <TagsAndMood data={dashboardData.coordinator.stats} />
          {/* <EngagementAndLearnerPace /> */}
          <StoryHighlights data={dashboardData.coordinator.stats} />
        </Grid>
      </Grid>
    </div>
  )
}

export default DashboardPage
